import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ProductosService } from '../../services/productos.service';
import { ActivatedRoute, Router } from '@angular/router';
import {ProductI} from '../../shared/product.interface';

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss']
})
export class ProductsComponent implements OnInit {
  @ViewChild('sectionSubscribe', { static: true }) sectionSubscribeDiv: ElementRef;
  categorias = false;
  busqueda = false;
  filterProducto = '';
  rango = '0';
  categoria: string;
  lista: any;
  prodListAll: any;
  productos: ProductI[] = [];
  constructor(private productoSvc: ProductosService,
              private route: ActivatedRoute,
              private router: Router) { }

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    this.loadStorage(id);
    this.scrollToSubscribe();
  }

  loadStorage(id: string){
    if (localStorage.getItem('dataProdTorreonmarket')) {
      this.lista = JSON.parse( localStorage.getItem('dataProdTorreonmarket'));
      this.prodListAll = JSON.parse( localStorage.getItem('dataProdTorreonmarket'));
      for (let i = 0; i < this.lista.length; i++) {
        const prd = this.lista[i];
        for (let a = 0; a < prd.categoria.length; a++) {
          const catsel = prd.categoria[a];
          if (catsel === id) {
            this.productos.push(prd);
          }
        }
      }
    }
  }

  scrollToSubscribe(){
    this.sectionSubscribeDiv.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  activarCategorias(){
    this.categorias = true;
  }

  loadByCategory(categoria: string){
    this.categorias = false;
    this.busqueda = false;
    this.productos = [];
    const id = categoria;
   this.loadStorage(id);
  }
  allProducts(){
    this.productos = this.prodListAll;
  }
  searchProductActivate(){
    this.busqueda = true;
    this.productos = [];
    this.lista = '';
    this.productoSvc.loadAllProductsActivate()
                   .subscribe(res => {
                     this.lista = res;
                   });
  }

  value(event: any){
    this.rango = event;
  }

  openProduct(producto: string){
    this.router.navigate([`/producto/${producto}`]);
  }
}
